import BookCard from "./../components/BookCard";
import ShadcnTable from "./../components/ShadcnTable";
// import "./style.css";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons";

import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../../ui/carousel";
// import Autoplay from "embla-carousel-autoplay"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../ui/select";
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
} from "./../../ui/table";
import { Button } from "../../ui/ot";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { useNews } from "../../news/controller/NewsController";
import dayjs from "dayjs";
import { useNewsType } from "../../news/controller/NewsTypeController";
import { useNavigate } from "react-router-dom";
import {
    Form, Row, Col, Input, Typography
} from '../../ui/ot'
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { QuestionAndAnswerAccordion } from "../../question_and_answer/views/question_and_answer";
// import { Calendar } from "../../ui/calendar"
import AdvancedSearchForm from './advanced_search_form'
import { useFile } from "../controllers/useFile";
const Styletable = styled.div`
  .p-4 {
    padding: 1em !important;
  }
`;
const NewsItems = [
    {
        key: 1,
        type: "最新消息",
        date: "2024-1-1",
        title: "最新書刊公告",
    },
    {
        key: 2,
        type: "最新消息",
        date: "2024-1-1",
        title: "最新書刊公告",
    },
    {
        key: 3,
        type: "最新消息",
        date: "2024-1-1",
        title: "最新書刊公告",
    },
    {
        key: 4,
        type: "最新消息",
        date: "2024-1-1",
        title: "最新書刊公告",
    },
];
const RankItems = [
    {
        key: 1,
        type: "1st",
        title: "最新書刊公告",
    },
    {
        key: 2,
        type: "2nd",
        title: "最新書刊公告",
    },
    {
        key: 3,
        type: "3rd",
        title: "最新書刊公告",
    },
    {
        key: 4,
        type: "4th",
        title: "最新書刊公告",
    },
    {
        key: 5,
        type: "5th",
        title: "最新書刊公告",
    },
];

const Home = ({
    propsNavigateSearchPath = '/online_public_catalog_query_construction/search_function',
    propsCarouselItems = [],
    otherComponent = []
}) => {
    const navigate = useNavigate();
    const [mytab, setTab] = useState("News");
    const [mode, setMode] = useState("Home");
    const [selectedButton, setSelectedButton] = useState(null);
    const [advancedSearch, setAdvancedSearch] = useState(false)

    const [form] = Form.useForm(); //form
    const [advanced_search_form] = Form.useForm(); //form 

    const onSubmit = (values) => {
        navigate(`./search_function?` + new URLSearchParams(values));
    };

    //   const { newBibData, getNewBibData } = useBib({
    //     onBefore: () => {},
    //     onFinish: () => {},
    //   });


    const { newsTypeOption, getNewsTypeOption } = useNewsType({
        onFinish: () => {
        },
        onBefore: () => { },
    });

    const { NewsData, getNewsData } = useNews({
        onFinish: () => { },
        onBefore: () => { },
    });

    useEffect(() => {
        //getNewBibData();
        getNewsData({
            // cur_page: 1,
            // size: 5,
            news_type_id: selectedButton,
            news_time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            is_news_time_end: 0,
        });
        getNewsTypeOption({});
        form.setFieldsValue({ type: "0" })

    }, []);
    useEffect(() => {
        getNewsData({
            // cur_page: 1,
            // size: 5,
            news_type_id: selectedButton,
            news_time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            is_news_time_end: 0,
        });
    }, [selectedButton])

    return (
        <Row gutter={[8, 8]}>
            <Col
                span={24}
            >
                <Row gutter={[8, 8]} >
                    <Col span={24}>
                        <FullWidthCarousel
                            items={propsCarouselItems}
                        />
                    </Col>
                    <Col span={24}>
                        <Row justify="center" gutter={[8, 16]}>
                            <Col span={24}>
                            </Col>
                            <Col xxl={18} xl={18} lg={20} md={24} sm={24} xs={24}>
                                <Form
                                    form={form}
                                    onValuesChange={() => { }}
                                    onFinish={onSubmit}
                                    autoComplete="off"
                                    initialValues={{
                                        type: "0"
                                    }}

                                >
                                    <Row justify="center" align={"middle"} gutter={[8, 8]}>
                                        <Col xxl={3} xl={3} lg={4} md={4} sm={4} xs={8}  >
                                            {/* <Form.Item
                                                name={"type"}

                                            >
                                                <Select
                                                    disabled={true}
                                                    // value="0"
                                                    placeholder="全部"
                                                >

                                                    <SelectTrigger placeholder="全部" className="inputBorder">
                                                        <SelectValue placeholder="全部" />
                                                    </SelectTrigger>
                                                    <SelectContent>
                                                        <SelectItem value="0">
                                                            <span className="text-nowrap">全部</span>
                                                        </SelectItem>
                                                        <SelectItem value="1">
                                                            <span className="text-nowrap">館藏</span>
                                                        </SelectItem>
                                                        <SelectItem value="2">
                                                            <span className="text-nowrap">電子書</span>
                                                        </SelectItem>
                                                        <SelectItem value="3">
                                                            <span className="text-nowrap">論文</span>
                                                        </SelectItem>
                                                    </SelectContent>
                                                </Select>
                                            </Form.Item> */}
                                        </Col>
                                        <Col xxl={15} xl={15} lg={16} md={16} sm={24} xs={22} >
                                            <Form.Item

                                                name={"keyword"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請輸入",
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder="搜尋館藏"
                                                    className="inputBorder"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={4} md={4} sm={24} xs={24} >
                                            <Row

                                                gutter={[8, 16]}
                                                justify="center"
                                            >
                                                <Col>
                                                    <Button
                                                        type="submit"
                                                        className="rounded-full h-10 px-4 "
                                                        style={{
                                                            fontSize: "1.6em",
                                                            //  height: "90%" 
                                                        }}

                                                        onClick={() => {
                                                            if (!!advancedSearch) {
                                                                advanced_search_form.submit()
                                                            }
                                                            else {
                                                                form.submit()
                                                            }

                                                        }}
                                                    >
                                                        查詢
                                                    </Button>
                                                </Col>
                                                <Col >
                                                    <Button
                                                        type="submit"
                                                        className=" h-10 px-4 rounded-full"
                                                        style={{ fontSize: "1.6em", }}

                                                        onClick={() => {
                                                            setAdvancedSearch((pre) => {
                                                                if (!pre) {
                                                                    advanced_search_form.setFieldsValue({
                                                                        search: [
                                                                            {
                                                                                operator: "and",
                                                                                field: "keyword",
                                                                                keyword: ""
                                                                            }
                                                                        ]
                                                                    })
                                                                }

                                                                return !pre
                                                            })

                                                        }}
                                                    >
                                                        {advancedSearch ? "一般查詢" : "進階查詢"}
                                                    </Button>
                                                </Col>
                                                <Col span={24}>
                                                </Col>
                                            </Row>

                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                            {advancedSearch && <Col span={24}>
                                <Row justify="center">
                                    <Col xxl={20} xl={20} lg={20} md={22} sm={24} xs={24}>
                                        <AdvancedSearchForm
                                            propsForm={advanced_search_form}
                                            onFormFinish={(formValue) => {
                                                let { search } = formValue
                                                let values = {}
                                                search?.forEach((element, index) => {
                                                    if (!!index) {
                                                        values[`field${index + 1}`] = element?.field
                                                        values[`keyword${index + 1}`] = element?.keyword
                                                        values[`operator${index + 1}`] = element?.operator
                                                    }
                                                    else {
                                                        values[`field`] = element?.field
                                                        values[`keyword`] = element?.keyword
                                                    }
                                                });
                                                navigate(`./search_function?` + new URLSearchParams(values));
                                            }}
                                        />
                                    </Col>

                                </Row>
                            </Col>}
                        </Row>
                    </Col>

                    <Col span={24}>
                        <div
                            style={{
                                width: "100%",
                                margin: "auto",
                                padding: "2em 0",
                                background: "#ffe8d8",
                            }}
                        >
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Row justify={'center'}>
                                        <Col>
                                            <span
                                                style={{
                                                    borderBottom: "0.2em solid #F28D52",
                                                    paddingBottom: "0.3em",
                                                    fontWeight: 700,
                                                    color: "#4CAF50",
                                                    fontSize: "2rem",

                                                }}
                                            >
                                                最新資訊
                                                <FontAwesomeIcon icon={faBullhorn} />
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24}></Col>
                                <Col span={24}></Col>
                                <Col span={24}>
                                    <Row justify={'center'} gutter={[16, 16]}>
                                        {
                                            newsTypeOption?.map((value) => {
                                                return (
                                                    <Col>
                                                        <Button
                                                            className="mytabactive rounded-full"
                                                            style={{
                                                                padding: "0.5em 1em",
                                                                fontSize: "1.2em",
                                                                backgroundColor: selectedButton === value?.news_type_id ? "white" : "orange",
                                                                color: selectedButton === value?.news_type_id ? "orange" : "white",
                                                            }}
                                                            onClick={() => {

                                                                setSelectedButton(value?.news_type_id)
                                                            }}
                                                        >
                                                            {value?.news_type_name}
                                                        </Button>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Row justify={'center'} >
                                        <Col xxl={20} xl={20} lg={22} md={23} sm={24} xs={24}>
                                            <div
                                                style={{
                                                    width: "100%",
                                                }}
                                            >
                                                <Table style={{ backgroundColor: "#ffece1 " }}>
                                                    <TableBody>
                                                        {NewsData.map((e) => (
                                                            <TableRow
                                                                key={e.key}
                                                                style={{
                                                                    borderBottom: "2px solid #ddd",
                                                                    padding: "0.5em 0",
                                                                }}
                                                            >
                                                                {e?.news_time && (
                                                                    <TableCell
                                                                        style={{
                                                                            padding: "0.5em 1em",
                                                                            width: "8em",
                                                                            textAlign: "left",
                                                                            fontSize: "1em",
                                                                            color: "#a465ee",
                                                                            fontWeight: "bold",
                                                                            whiteSpace: "nowrap",
                                                                            backgroundColor: "#ffe8d8", // 日期欄位背景色
                                                                        }}
                                                                    >
                                                                        {e?.news_time ? dayjs(e?.news_time).format("YYYY-MM-DD") : "-"}
                                                                    </TableCell>
                                                                )}
                                                                <TableCell
                                                                    style={{
                                                                        padding: "0.5em 1em",
                                                                        fontSize: "1.6em",
                                                                        color: "#333",
                                                                        fontWeight: "bold",
                                                                        backgroundColor: "#ffe8d8", // 標題欄位背景色
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    <div
                                                                        onClick={() => {
                                                                            navigate(`new?news_id=${e?.news_id}`)

                                                                        }}>
                                                                        {e?.news_title}

                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                {/* <Col span={24}>
                                    <Row gutter={[8, 8]} justify="end">
                                        <Col>
                                            <a
                                                href="*"
                                                style={{
                                                    padding: "0.5em 1em",
                                                    backgroundColor: "#66CC99",
                                                    color: "white",
                                                    textDecoration: "none",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                查看更多
                                            </a>
                                        </Col>
                                    </Row>
                                </Col> */}

                            </Row>





                        </div>
                    </Col>
                    {
                        otherComponent?.map((component) => {

                            return (
                                <Col span={24}>
                                    {component}
                                </Col>
                            )
                        })
                    }
                    <Col span={24}>
                        <Row justify="center">
                            <Col span={20}>
                                <QuestionAndAnswerAccordion />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* 
               
                <div style={{ width: "90%", margin: "auto", padding: "2em 0" }}></div>
                <div
                    style={{
                        fontSize: "1.6em",
                        textAlign: "center",
                        margin: "0 0 1em 0",
                    }}
                >
                    <span
                        style={{
                            borderBottom: "0.2em solid #F28D52",
                            paddingBottom: "0.3em",
                            fontWeight: 700,
                        }}
                    >
                        動態連結
                    </span>
                </div>
                <div style={{ width: "60%", margin: "auto" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            alignItems: "center",
                            gap: "1em", // 縮小間距
                        }}
                    >
                        <Button
                            style={{
                                width: "150px",
                                height: "150px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "12px",
                                border: "2px solid #ccc",
                                background: "#efbaba",
                            }}
                        >
                            <img
                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M12 2C10.5 2 8.75 2.5 7 3.25C5.25 4 3.5 5 2 6V19.5C2 20.3 2.7 21 3.5 21C4.3 21 4.9 20.3 5 19.5C6 18 7 16.8 8 16V7C9 7.5 10 8 12 8C14 8 15 7.5 16 7V16C17 16.8 18 18 19 19.5C19.1 20.3 19.7 21 20.5 21C21.3 21 22 20.3 22 19.5V6C20.5 5 18.75 4 17 3.25C15.25 2.5 13.5 2 12 2Z' fill='%23EB5A51'/%3E%3C/svg%3E"
                                alt="book icon"
                                style={{ width: "50px", height: "50px" }}
                            />

                            <span
                                style={{
                                    fontSize: "1.2em",
                                    fontWeight: "bold",
                                    color: "#6a5acd",
                                }}
                            >
                                個人書室
                            </span>
                        </Button>

                        <Button
                            style={{
                                width: "150px",
                                height: "150px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "12px",
                                border: "2px solid #ccc",
                                background: "#efbaba",
                            }}
                        >
                            <img
                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M6 2H14C15.1 2 16 2.9 16 4V18C16 19.1 15.1 20 14 20H6C4.9 20 4 19.1 4 18V4C4 2.9 4.9 2 6 2Z' fill='%234A4A4A'/%3E%3Cpath d='M5 19C5 19.55 5.45 20 6 20H14C14.55 20 15 19.55 15 19C15 18.45 14.55 18 14 18H6C5.45 18 5 18.45 5 19Z' fill='%23D1D1D1'/%3E%3Ccircle cx='18' cy='18' r='4' fill='%234A4AFA'/%3E%3Cpath d='M18 16V18H20' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"
                                alt="book with clock icon"
                                style={{ width: "50px", height: "50px" }}
                            />
                            <span
                                style={{
                                    fontSize: "1.2em",
                                    fontWeight: "bold",
                                    color: "#6a5acd",
                                }}
                            >
                                讀者紀錄
                            </span>
                        </Button>

                        <Button
                            onClick={() => setTab("News")}
                            style={{
                                width: "150px",
                                height: "150px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "12px",
                                border: "2px solid #ccc",
                                background: "#efbaba",
                            }}
                        >
                            <img
                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 24 24' fill='none'%3E%3Crect x='4' y='4' width='16' height='16' rx='2' fill='%236D4C41'/%3E%3Cpath d='M10 12H16M14 10L16 12L14 14' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"
                                alt="arrow icon"
                                style={{ width: "50px", height: "50px" }}
                            />

                            <span
                                style={{
                                    fontSize: "1.2em",
                                    fontWeight: "bold",
                                    color: "#6a5acd",
                                }}
                            >
                                登出帳號
                            </span>
                        </Button>
                    </div>
                </div>
                <div>
                    <div
                        style={{
                            fontSize: "1.6em",
                            textAlign: "center",
                            margin: "0 0 1em 0",
                        }}
                    >
                        <span
                            style={{
                                borderBottom: "0.2em solid #F28D52",
                                paddingBottom: "0.3em",
                                fontWeight: 700,
                            }}
                        >
                            AI智慧推薦書籍
                        </span>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            textAlign: "center",
                            margin: "1em 0",
                            alignItems: "right",
                        }}
                    >
                        <FormItem>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="依借閱書籍關鍵字" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="all">依借閱書籍關鍵字</SelectItem>
                                    <SelectItem value="ai">依熱門話題</SelectItem>
                                    <SelectItem value="tech">依星座相似推薦</SelectItem>
                                </SelectContent>
                            </Select>
                        </FormItem>
                    </div>
                    <Carousel className="w-full h-full">
                        <CarouselContent>
                            {newBibData?.map((item) => (
                                <>
                                    <CarouselItem key={item.iOrder} className="basis-1/4">
                                        <BookCard
                                            title={
                                                item.bib_title + item.bib_subtitle + item.bib_author
                                            }
                                            src={
                                                "https://media.taaze.tw/showLargeImageByIsbn.ashx?width=139&height=179&isbn=" +
                                                item.bibitem_isbn
                                            }
                                        />
                                    </CarouselItem>
                                </>
                            ))}
                        </CarouselContent>
                        <CarouselPrevious />
                        <CarouselNext />
                    </Carousel>
                </div>

                <div style={{ width: "100%", margin: "auto" }}>
                    <div
                        style={{
                            fontSize: "1.6em",
                            textAlign: "center",
                            margin: "0 0 1em 0",
                        }}
                    >
                        <span
                            style={{
                                borderBottom: "0.2em solid #F28D52",
                                paddingBottom: "0.3em",
                                fontWeight: 700,
                            }}
                        >
                            借閱排行
                        </span>
                    </div>
                    <ShadcnTable item={RankItems} />
                </div> */}
            </Col>
            {/* <Col
                className="srwd midcontainer"
                style={{ gap: "1em", marginBottom: "1em" }}
            >
                <div>
                    <Carousel className="w-full h-full" opts={{ loop: true }}>
                        <CarouselContent>
                            <CarouselItem key={1}>
                                <div
                                    className="imgdiv headerBanner"
                                    style={{
                                        backgroundImage:
                                            "url(https://i.pinimg.com/564x/7a/d4/fe/7ad4fe684437d02beac8a7b7b525bb10.jpg)",
                                    }}
                                />
                            </CarouselItem>
                            <CarouselItem key={2}>
                                <div className="imgdiv headerBanner" style={{}} />
                            </CarouselItem>
                            <CarouselItem key={3}>
                                <div className="imgdiv headerBanner" style={{}} />
                            </CarouselItem>
                        </CarouselContent>
                        <CarouselPrevious />
                        <CarouselNext />
                    </Carousel>
                </div>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)}>
                        <div
                            style={{
                                padding: "1em 0.5em",
                                display: "flex",
                                gap: "1em",
                                width: "100%",
                            }}
                        >
                            <div>
                                <FormField
                                    control={form.control}
                                    name="type"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select defaultValue={field.value}>
                                                <FormControl>
                                                    <SelectTrigger className="inputBorder">
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value="0">
                                                        <span className="text-nowrap">全部</span>
                                                    </SelectItem>
                                                    <SelectItem value="1">
                                                        <span className="text-nowrap">館藏</span>
                                                    </SelectItem>
                                                    <SelectItem value="2">
                                                        <span className="text-nowrap">電子書</span>
                                                    </SelectItem>
                                                    <SelectItem value="3">
                                                        <span className="text-nowrap">論文</span>
                                                    </SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </div>
                            <div style={{ width: "-webkit-fill-available" }}>
                                <FormField
                                    control={form.control}
                                    name="keyword"
                                    render={({ field }) => (
                                        <FormItem>
                                            <FormControl>
                                                <Input
                                                    placeholder="搜尋館藏"
                                                    className="inputBorder"
                                                    {...field}
                                                />
                                            </FormControl>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </div>
                            <div>
                                <FormField
                                    control={form.control}
                                    name="type"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select defaultValue={field.value}>
                                                <FormControl>
                                                    <SelectTrigger className="inputBorder">
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value="0">
                                                        <span className="text-nowrap">全部</span>
                                                    </SelectItem>
                                                    <SelectItem value="1">
                                                        <span className="text-nowrap">選項1</span>
                                                    </SelectItem>
                                                    <SelectItem value="2">
                                                        <span className="text-nowrap">選項2</span>
                                                    </SelectItem>
                                                    <SelectItem value="3">
                                                        <span className="text-nowrap">選項3</span>
                                                    </SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </div>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <Button type="submit" className="mytabactive rounded-full">
                                    查詢
                                </Button>
                            </div>
                        </div>
                    </form>
                </Form>
                <div
                    style={{
                        width: "90%",
                        margin: "auto",
                        padding: "2em 0",
                        background: "#ffe8d8",
                    }}
                >
                    <div
                        style={{
                            fontSize: "2rem",
                            textAlign: "center",
                            margin: "0 0 1em 0",
                        }}
                    >
                        <span
                            style={{
                                borderBottom: "0.2em solid #F28D52",
                                paddingBottom: "0.3em",
                                fontWeight: 700,
                                color: "#4CAF50",
                            }}
                        >
                            最新資訊
                            <FontAwesomeIcon icon={faBullhorn} />
                        </span>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "1em",
                            paddingBottom: "1em",
                        }}
                    >
                        <Button
                            className="mytabactive rounded-full"
                            style={{
                                padding: "0.5em 1em",
                                fontSize: "1.2em",
                                backgroundColor: selectedButton === 1 ? "orange" : "white",
                            }}
                            onClick={() => handleButtonClick(1)}
                        >
                            最新消息
                        </Button>
                        <Button
                            className="mytabactive rounded-full"
                            style={{
                                padding: "0.5em 1em",
                                fontSize: "1.2em",
                                backgroundColor: selectedButton === 2 ? "orange" : "white",
                            }}
                            onClick={() => handleButtonClick(2)}
                        >
                            總館活動
                        </Button>
                        <Button
                            className="mytabactive rounded-full"
                            style={{
                                padding: "0.5em 1em",
                                fontSize: "1.2em",
                                backgroundColor: selectedButton === 3 ? "orange" : "white",
                            }}
                            onClick={() => handleButtonClick(3)}
                        >
                            分館活動
                        </Button>
                        <Button
                            className="mytabactive rounded-full"
                            style={{
                                padding: "0.5em 1em",
                                fontSize: "1.2em",
                                backgroundColor: selectedButton === 4 ? "orange" : "white",
                            }}
                            onClick={() => handleButtonClick(4)}
                        >
                            活動與公告
                        </Button>
                        <Button
                            className="mytabactive rounded-full"
                            style={{
                                padding: "0.5em 1em",
                                fontSize: "1.2em",
                                backgroundColor: selectedButton === 5 ? "orange" : "white",
                            }}
                            onClick={() => handleButtonClick(5)}
                        >
                            新聞資訊
                        </Button>
                    </div>
                    <Table style={{ backgroundColor: "#ffece1 " }}>
                        <TableBody>
                            {NewsItems.map((e) => (
                                <TableRow
                                    key={e.key}
                                    style={{
                                        borderBottom: "2px solid #ddd",
                                        padding: "0.5em 0",
                                    }}
                                >
                                    {e.date ? (
                                        <TableCell
                                            style={{
                                                padding: "0.5em 1em",
                                                width: "8em",
                                                textAlign: "left",
                                                fontSize: "1em",
                                                color: "#a465ee",
                                                fontWeight: "bold",
                                                whiteSpace: "nowrap",
                                                backgroundColor: "#ffe8d8", // 日期欄位背景色
                                            }}
                                        >
                                            {e.date}
                                        </TableCell>
                                    ) : null}
                                    <TableCell
                                        style={{
                                            padding: "0.5em 1em",
                                            fontSize: "1.6em",
                                            color: "#333",
                                            fontWeight: "bold",
                                            backgroundColor: "#ffe8d8", // 標題欄位背景色
                                        }}
                                    >
                                        {e.title}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>


                    <div style={{ width: "100%", textAlign: "end", marginTop: "1em" }}>
                        <a
                            href="*"
                            style={{
                                padding: "0.5em 1em",
                                backgroundColor: "#66CC99",
                                color: "white",
                                textDecoration: "none",
                                borderRadius: "5px",
                            }}
                        >
                            查看更多
                        </a>
                    </div>
                </div>
                
                <div>
                    <div
                        style={{
                            fontSize: "1.6em",
                            textAlign: "center",
                            margin: "0 0 1em 0",
                        }}
                    >
                        <span
                            style={{
                                borderBottom: "0.2em solid #F28D52",
                                paddingBottom: "0.3em",
                                fontWeight: 700,
                            }}
                        >
                            動態連結
                        </span>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            alignItems: "center",
                            gap: "2em",
                        }}
                    >
                        <Button
                            style={{
                                background: "#000"
                            }}

                        >
                            <img
                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M12 2C10.5 2 8.75 2.5 7 3.25C5.25 4 3.5 5 2 6V19.5C2 20.3 2.7 21 3.5 21C4.3 21 4.9 20.3 5 19.5C6 18 7 16.8 8 16V7C9 7.5 10 8 12 8C14 8 15 7.5 16 7V16C17 16.8 18 18 19 19.5C19.1 20.3 19.7 21 20.5 21C21.3 21 22 20.3 22 19.5V6C20.5 5 18.75 4 17 3.25C15.25 2.5 13.5 2 12 2Z' fill='%23EB5A51'/%3E%3C/svg%3E"
                                alt="book icon"
                                style={{ width: "50px", height: "50px" }}
                            />

                            <span
                                style={{
                                    fontSize: "1.2em",
                                    fontWeight: "bold",
                                    color: "#6a5acd",
                                }}
                            >
                                個人書室
                            </span>
                        </Button>

                        <Button
                            style={{
                                width: "150px",
                                height: "150px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "12px",
                                border: "2px solid #ccc",
                                background: "#efbaba",
                            }}
                        >
                            <img
                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M6 2H14C15.1 2 16 2.9 16 4V18C16 19.1 15.1 20 14 20H6C4.9 20 4 19.1 4 18V4C4 2.9 4.9 2 6 2Z' fill='%234A4A4A'/%3E%3Cpath d='M5 19C5 19.55 5.45 20 6 20H14C14.55 20 15 19.55 15 19C15 18.45 14.55 18 14 18H6C5.45 18 5 18.45 5 19Z' fill='%23D1D1D1'/%3E%3Ccircle cx='18' cy='18' r='4' fill='%234A4AFA'/%3E%3Cpath d='M18 16V18H20' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"
                                alt="book with clock icon"
                                style={{ width: "50px", height: "50px" }}
                            />
                            <span
                                style={{
                                    fontSize: "1.2em",
                                    fontWeight: "bold",
                                    color: "#6a5acd",
                                }}
                            >
                                讀者紀錄
                            </span>
                        </Button>

                        <Button
                            onClick={() => setTab("News")}
                            style={{
                                width: "150px",
                                height: "150px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "12px",
                                border: "2px solid #ccc",
                                background: "#efbaba",
                            }}
                        >
                            <img
                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 24 24' fill='none'%3E%3Crect x='4' y='4' width='16' height='16' rx='2' fill='%236D4C41'/%3E%3Cpath d='M10 12H16M14 10L16 12L14 14' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"
                                alt="arrow icon"
                                style={{ width: "50px", height: "50px" }}
                            />

                            <span
                                style={{
                                    fontSize: "1.2em",
                                    fontWeight: "bold",
                                    color: "#6a5acd",
                                }}
                            >
                                登出帳號
                            </span>
                        </Button>
                    </div>
                </div>
                <div>
                    <div
                        style={{
                            fontSize: "1.6em",
                            textAlign: "center",
                            margin: "0 0 1em 0",
                        }}
                    >
                        <span
                            style={{
                                borderBottom: "0.2em solid #F28D52",
                                paddingBottom: "0.3em",
                                fontWeight: 700,
                            }}
                        >
                            AI智慧推薦書籍
                        </span>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            textAlign: "center",
                            margin: "1em 0",
                            alignItems: "right",
                        }}
                    >
                        <FormItem>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="依借閱書籍關鍵字" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="all">依借閱書籍關鍵字</SelectItem>
                                    <SelectItem value="ai">依熱門話題</SelectItem>
                                    <SelectItem value="tech">依星座相似推薦</SelectItem>
                                </SelectContent>
                            </Select>
                        </FormItem>
                    </div>

                    <Carousel className="w-full h-full">
                        <CarouselContent>
                            {newBibData?.map((item) => (
                                <CarouselItem key={item.iOrder} className="basis-1/4">
                                    <BookCard
                                        title={`${item.bib_title} ${item.bib_subtitle} / ${item.bib_author}`}
                                        src={`https://media.taaze.tw/showLargeImageByIsbn.ashx?width=139&height=179&isbn=${item.bibitem_isbn}`}
                                    />
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <CarouselPrevious />
                        <CarouselNext />
                    </Carousel>
                </div>

                <div style={{ width: "90%", margin: "auto" }}>
                    <div style={{ width: "100%" }}></div>
                </div>
                <div style={{ width: "90%", margin: "auto" }}>
                    <div
                        style={{
                            fontSize: "1.6em",
                            textAlign: "center",
                            margin: "0 0 1em 0",
                        }}
                    >
                        <span
                            style={{
                                borderBottom: "0.2em solid #F28D52",
                                paddingBottom: "0.3em",
                                fontWeight: 700,
                            }}
                        >
                            借閱排行
                        </span>
                    </div>
                    <ShadcnTable item={RankItems} />
                </div>
            </Col> */}
        </Row>
    );
};

export default Home;

const FullWidthCarousel = ({
    items = [
        {
            file_id: 4623
        },
        {
            file_id: 4624
        },
        {
            file_id: 4623
        },
    ]
}) => {
    const [currentSlide, setCurrentSlide] = useState(0)
    const [isPaused, setIsPaused] = useState(false)
    const nextSlide = () => {
        setCurrentSlide((prev) => (prev === items?.length - 1 ? 0 : prev + 1))
    }

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? items?.length - 1 : prev - 1))
    }

    const goToSlide = (index) => {
        setCurrentSlide(index)
    }

    // Auto-play functionality
    useEffect(() => {
        if (!isPaused) {
            const interval = setInterval(() => {
                nextSlide()
            }, 4000)
            return () => clearInterval(interval)
        }
    }, [currentSlide, isPaused])
    return (
        <div
            className="relative w-full overflow-hidden"
            style={{
                // height: "calc(100vw * 0.5625)" /* 16:9 aspect ratio (9/16 = 0.5625) */,
                // maxHeight: "calc(100vh - 80px)" /* Prevent it from being too tall */,
                height: "66.67vh" /* 2/3 of viewport height */,
            }}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            {/* Slides */}
            <div className="relative w-full h-full">
                {items?.map((slide, index) => (
                    <div
                        key={index}
                        className={
                            `absolute top-0 left-0 w-full h-full transition-opacity duration-1000 ${index === currentSlide ? "opacity-100 z-10" : "opacity-0 z-0"}`
                        }
                    >
                        <CarouselImage {...slide} />
                    </div>
                ))}
            </div>

            {/* Indicators */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex space-x-2">
                {items?.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => goToSlide(index)}
                        className={
                            `w-3 h-3 rounded-full transition-colors ${index === currentSlide ? "bg-white" : "bg-white/50 hover:bg-white/70"}`
                        }
                        aria-label={`Go to slide ${index + 1}`}
                        aria-current={index === currentSlide ? "true" : "false"}
                    />
                ))}
            </div>
        </div>
    )
}

const CarouselImage = ({
    file_id
}) => {
    const { file, getFile } = useFile()
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        setLoading(true)
        file_id ?
            getFile(file_id)
            :
            setLoading(false)
    }, [file_id])
    useEffect(() => {
        file && setLoading(false)
    }, [file])


    return (
        <>{
            loading ?
                <></>
                : file ?
                    <img
                        src={file}
                        // alt={slide?.alt}
                        fill
                        priority
                        className="object-cover object-center w-full h-full"
                    />
                    : <></>
        }</>


    )
}
export {
    FullWidthCarousel
}
